import { useContext } from "react";
import { BrandingContext } from "./model";

export const useBranding = () => useContext(BrandingContext);

export const useClientId = () => {
    const { clientId } = useBranding();

    return clientId;
};
